// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.m-document-create-edit-content-select-required .c-input-required {\n  opacity: 1!important;\n  visibility: visible!important;\n}\n", ""]);
// Exports
module.exports = exports;
